export interface InvoiceDTO {
  id: string;
  orderNumber: string;
  to: string;
  amount: Amount;
  outstandingAmount: Amount;
  notes: string;
  createdDate: Date;
  invoiceDate: Date;
  dueDate: Date;
  hasBeenPaid: boolean;
  items: InvoiceItem[];
  contact: Contact;
  type: InvoiceType;
  hasBillingSite: boolean;
  dateProformaScrapped?: Date;
  isPaymentLinkedToInvoice: boolean;
  isPaymentInProgress: boolean;
  itemsPaidByCard: number;
  isGuest: boolean;
  isPaymentLinkedToASuspendedService: boolean;
}

export enum InvoiceType {
  Unknown = "Unknown",
  Invoice = "Invoice",
  Credit = "Credit",
  ProForma = "ProForma"
};

export interface InvoiceItem {
  id: string;
  invoiceId: string;
  type: string;
  description: string;
  product: Product;
  amount: Amount;
  quantity: number;
  prepaymentMonths: number;
  serviceStartDate: string;
  serviceEndDate: string;
  identifiers: Identifier[];
}

export interface Amount{
  amountExVat: number;
  amountIncVat: number;
  vatTotal: number;
  vatRate: VatRate;
}

export interface VatRate{
  rate: number;
  description: string;
}

export interface Product{
  id: number;
  code: string;
  name: string;
}

export interface Identifier {
  key: string;
  desc: string;
  value: string;
}

export interface Contact {
  firstname: string;
  surname: string;
  addressLineOne: string;
  town: string;
  city: string;
  postCode: string;
  phone: string;
  organisationName: string;
}